export default __webpack_public_path__ + "static/media/Karnataka4.56345b22.png";